module.exports = __webpack_public_path__ + "static/media/arrow_down_grey.01df552a.svg";